import { useQuery, useQueryClient } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { ScopedEnablementQueries } from '@portal/pkg-authorization'
import { UserInfoQueries } from '@shared/data'
import { router } from '@shared/router/router'

export const Router = () => {
  const queryClient = useQueryClient()

  const { data: effectiveUser } = useQuery(UserInfoQueries.userInfo())
  const { data: scopedEnablements } = useQuery(ScopedEnablementQueries.scopedEnablements())
  return (
    <RouterProvider
      router={router}
      context={{
        queryClient,
        effectiveUser: effectiveUser?.impersonated ?? effectiveUser?.real,
        realUser: effectiveUser?.real,
        scopedEnablements,
      }}
    />
  )
}
